import { Action } from '@ngrx/store';
import {Region} from '../region.model';
import {Update} from '@ngrx/entity';

export enum RegionActionTypes {
  GetRegions = '[Region] Get Regions',
  LoadRegions = '[Region] Load Regions',
  UpdateRegions = '[Region] Update Region',
  DeleteRegions = '[Region] Delete Region',
  AddRegions = '[Region] Add Region',
  RemoveRegions = '[Region] Remove Region'
}


export class GetRegions implements Action {
  readonly type = RegionActionTypes.GetRegions;
}

export class LoadRegions implements Action {
  readonly type = RegionActionTypes.LoadRegions;
  constructor(public payload: Region[] ) {}
}

export class UpdateRegions implements Action {
  readonly type = RegionActionTypes.UpdateRegions;
  constructor(public payload: any = null ) {}
}

export class DeleteRegions implements Action {
  readonly type = RegionActionTypes.DeleteRegions;
  constructor(public payload: any = null) {}
}

export class AddRegions implements Action {
  readonly type = RegionActionTypes.AddRegions;
  constructor(public payload: any = null ) {}
}

export class RemoveRegions implements Action {
  readonly type = RegionActionTypes.RemoveRegions;
}


export type RegionActions = LoadRegions
  | GetRegions
  | UpdateRegions
  | DeleteRegions
  | AddRegions
  | RemoveRegions;
